<template>
  <div>
    <rabbey-table-3
      :data="reportData"
      :columns="reportColumns"
      :actions="reportActions"
      :loading="reportDataLoading"
    />
  </div>
</template>

<script>
import { columns } from "@/columns/RequestReportByModuleByMonth/RequestReportByModuleByMonthColumns";

const actualYear = new Date().getFullYear();

export default {
  name: "ClientRabbeyReportByModuleByMonthTable",
  props: {
    yearSelected: {
      type: Number,
      default: actualYear
    },
    thecnicianSelected: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      reportData: [],
      reportColumns: columns(this),
      reportActions: [],
      reportDataLoading: false
    };
  },

  mounted() {
    this.GetReportData();
  },

  methods: {
    async GetReportData() {
      this.reportDataLoading = true;
      await this.$http
        .get("api/serviceRequests/Get_External_Request_Report_By_Modules", {
          params: {
            year: this.yearSelected,
            responsibleId: this.thecnicianSelected
          }
        })
        .then((response) => {
          this.reportData = response.data;
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.reportDataLoading = false;
        });
    }
  },
  watch: {
    async yearSelected() {
      await this.GetReportData();
    },
    async thecnicianSelected() {
      await this.GetReportData();
    }
  }
};
</script>

<style scoped></style>
